'use client';

import { Stack, Typography } from '@mui/material';
import {
  BackupStatus,
  type InventoryResource,
  type SecurityScan,
} from '@repo/api-gw-sdk';

import { BackupStatusIcon } from '@/components/backupStatus/backupStatusIcon';

import { StatusCardHeader } from '../panels/instance/tabs/overview-tab/statusCardHeader';
import { StatusCardWrapper } from '../panels/instance/tabs/overview-tab/statusCardWrapper';

interface DataAnomalyCleanCardProps {
  resource: InventoryResource;
  lastScan: SecurityScan;
}

export const DataAnomalyCleanCard = ({
  resource,
  lastScan,
}: DataAnomalyCleanCardProps) => {
  return (
    <StatusCardWrapper borderColor='var(--mui-palette-success-main)'>
      <Stack marginLeft='40px' marginRight='24px'>
        <StatusCardHeader
          title='Anomaly Detection'
          actions={[]}
          entity={resource}
        />
      </Stack>
      <Stack alignItems='center' spacing='12px'>
        <BackupStatusIcon backupStatus={BackupStatus.Protected} />
        <Typography variant='h3'>No Anomaly Detected</Typography>
        {lastScan.justification && (
          <Typography
            align='center'
            width='65%'
            className='text-(--mui-palette-text-secondary) mb-[12px]'
            lineHeight='20px'
          >
            {lastScan.justification}
          </Typography>
        )}
      </Stack>
    </StatusCardWrapper>
  );
};
